import { render, staticRenderFns } from "./EditActivityTemplateDialog.vue?vue&type=template&id=533c9449"
import script from "./EditActivityTemplateDialog.vue?vue&type=script&lang=js"
export * from "./EditActivityTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports